var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormPropertyFactory, PropertyGroup } from "./angular2-schema-form-shim";
import { NumberProperty, StringProperty, BooleanProperty, ObjectProperty, ArrayProperty } from "./formproperty";
export function useFactory(schemaValidatorFactory, validatorRegistry) {
    return new SPFormPropertyFactory(schemaValidatorFactory, validatorRegistry);
}
var SPFormPropertyFactory = (function (_super) {
    __extends(SPFormPropertyFactory, _super);
    function SPFormPropertyFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SPFormPropertyFactory.prototype.createProperty = function (schema, parent, propertyId) {
        if (parent === void 0) { parent = null; }
        var newProperty = null;
        var path = '';
        if (parent) {
            path += parent.path;
            if (parent.parent !== null) {
                path += '/';
            }
            if (parent.type === 'object') {
                path += propertyId;
            }
            else if (parent.type === 'array') {
                path += '*';
            }
            else {
                throw 'Instanciation of a FormProperty with an unknown parent type: ' + parent.type;
            }
        }
        else {
            path = '/';
        }
        if (schema.$ref) {
            var refSchema = this.schemaValidatorFactory.getSchema(parent.root.schema, schema.$ref);
            newProperty = this.createProperty(refSchema, parent, path);
        }
        else {
            var effectiveType = Array.isArray(schema.type)
                ? schema.type.find(function (t) { return t !== 'null'; }) || schema.type[0]
                : schema.type;
            switch (effectiveType) {
                case 'integer':
                case 'number':
                    newProperty = new NumberProperty(this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
                    break;
                case 'string':
                    newProperty = new StringProperty(this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
                    break;
                case 'boolean':
                    newProperty = new BooleanProperty(this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
                    break;
                case 'object':
                    newProperty = new ObjectProperty(this, this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
                    break;
                case 'array':
                    newProperty = new ArrayProperty(this, this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
                    break;
                default:
                    throw new TypeError("Undefined type " + schema.type);
            }
        }
        if (newProperty instanceof PropertyGroup) {
            this.initializeRoot(newProperty);
        }
        return newProperty;
    };
    return SPFormPropertyFactory;
}(FormPropertyFactory));
export { SPFormPropertyFactory };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formpropertyfactory.ts.pre-build-optimizer.js